module.exports = __webpack_public_path__ + "static/img/bcg.00ba41de.jpg";